<template>
    <b-card>
        <div v-if="loading" class="loading"/>

        <div class="mb-2 mt-2">
            <div class="d-block d-md-inline-block pt-1">
                <h4 class="mb-2 card-title">List of Signatures</h4>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{ meta.from }}-{{ meta.to }} of {{ meta.total }}</span>
                <b-dropdown id="ddown2" right :text="`${meta.per_page}`" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <b-table show-empty no-sort-reset class="vuetable" :current-page="meta.current_page" :per-page="meta.per_page"
                 :fields="table.fields" :items="fetchFacilitySignatures">
            <template v-slot:cell(id)="data">
                <router-link class="text-data-link" :to="'/hms/signatures/' + data.item.links.self"
                             v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(date)="data">
                <span v-text="data.item.data.attributes.date"/>
            </template>

            <template v-slot:cell(occupied_units)="data">
                <span v-text="data.item.data.attributes.occupied_units"/>
            </template>

            <template v-slot:cell(total_signed)="data">
                <span v-text="data.item.data.attributes.total_signed"/>
            </template>

            <template v-slot:cell(sign_percentage)="data">
                <span v-text="data.item.data.attributes.sign_percentage"/>
            </template>
        </b-table>

        <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                      v-model="meta.current_page">
            <template v-slot:next-text>
                <i class="simple-icon-arrow-right"/>
            </template>

            <template v-slot:prev-text>
                <i class="simple-icon-arrow-left"/>
            </template>

            <template v-slot:first-text>
                <i class="simple-icon-control-start"/>
            </template>

            <template v-slot:last-text>
                <i class="simple-icon-control-end"/>
            </template>
        </b-pagination>
    </b-card>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "FacilitySignaturesList",
        data() {
            return {
                loading: true,
                table: {
                    fields: [
                        {key: 'id', label: 'Code'},
                        {key: 'date', label: 'Date', tdClass: 'text-muted'},
                        {key: 'occupied_units', label: 'Occupied Units', tdClass: 'text-muted'},
                        {key: 'total_signed', label: 'Total Signed', tdClass: 'text-muted'},
                        {key: 'sign_percentage', label: 'Sign Percentage', tdClass: 'text-muted'},
                    ]
                }
            }
        },

        computed: {
            ...mapGetters({
                meta: 'getFacilitySignaturesMeta',
            }),
        },

        methods: {
            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            fetchFacilitySignatures() {
                return this.$store.dispatch('fetchFacilitySignatures', this.$route.params.facility_id)
                    .then(units => {
                        return units.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        }
    }
</script>

<style scoped>

</style>
